import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface MoveTeamEligibilityDialogProps {
  open: boolean;
  teamName?: string;
  toDivisionName?: string;
  reasons: string[];
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// Shown when moving a team into a division whose eligibility (gender/age/rating)
// the team's players don't meet. Lists the offending players + rules and lets the
// admin override and move anyway. Reused by /admin/organize (drag) and
// /admin/registration (division dropdown).
export default function MoveTeamEligibilityDialog({
  open,
  teamName,
  toDivisionName,
  reasons,
  loading = false,
  onConfirm,
  onCancel,
}: MoveTeamEligibilityDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Eligibility check{toDivisionName ? `: ${toDivisionName}` : ""}</AlertDialogTitle>
          <AlertDialogDescription>
            {teamName ? <><strong>{teamName}</strong> doesn't</> : "This team doesn't"} meet
            {toDivisionName ? <> <strong>{toDivisionName}</strong>'s</> : " this division's"} requirements:
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="my-2 max-h-60 overflow-y-auto list-disc pl-5 space-y-1 text-sm text-muted-foreground">
          {reasons.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={loading}
            className="bg-destructive hover:bg-destructive/90"
          >
            Override &amp; Move
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
